<template>
        <el-popover class="word" width="300" trigger="hover" :content="scope.row[tableData.bind],tableData.formartAmout,scope.row| dataListFormat" placement="top-start">
            <span slot="reference" class="remark">
                {{scope.row[tableData.bind],tableData.formartAmout,scope.row| dataListFormat}}
            </span>
        </el-popover>
</template>
<script>
import filters from "@/mixins/filters";
import SkySuffix from "@/components/iglobalwin/formComponents/SkySuffix.vue";
export default {
  name: "default-text",
  props: ["tableData", "scope"],
  components: { SkySuffix },
  mixins: [filters],
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.remark {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.word {
    -ms-word-break: break-all;
    word-break: break-all;
}
</style>
